<template>
	<div id="modals" />
	<div id="root" />
	<template v-if="appReady">
		<ws-cache-refresher />
		<component :is="layout">
			<router-view />
		</component>
		<ws-loading-spinner />
	</template>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { getCurrentInstance } from "vue";
import { auth0 } from "@/auth/_globals";

const route = useRoute();
const loadedConsoleStrings = ref(false);
const appReady = computed(
	() =>
		loadedConsoleStrings.value &&
		(layout.value !== "app-layout" || auth0.isAuthenticated.value)
);
const instance = getCurrentInstance();
if (!instance) {
	throw new Error("Component instance not available");
}

const app = instance.appContext.app;

const layout = computed(() => {
	const layoutName = (route.meta?.layout as string | undefined) || "app";
	return `${layoutName.toLowerCase()}-layout`;
});

loadedConsoleStrings.value = true;

onMounted(async () => {
	await app.config.globalProperties.$setClientTitleAndFavicon();
});
</script>
